var _a;
import { isLanguageCode } from '../enums/LanguageCode';
import { isRetailUnit } from '../enums/RetailUnit';
import { splitPath } from './splitPath';
const baseDomain = window.location.hostname.split('.').slice(-2).join('.');
const [retailUnitString, languageString, appName, indexFile = ''] = splitPath(window.location.pathname);
const retailUnit = isRetailUnit(retailUnitString) ? retailUnitString : undefined;
const language = isLanguageCode(languageString) ? languageString : undefined;
const slotName = (_a = /index(-([a-z0-9-]+))?\.html/.exec(indexFile)) === null || _a === void 0 ? void 0 : _a[2];
const getBackendUrl = () => {
    if ([retailUnit, language, appName].every((v) => v === undefined)) {
        return;
    }
    if (process.env.NODE_ENV === 'development') {
        return `/${retailUnit}/${language}/${appName}`;
    }
    if (baseDomain === 'ikea.com') {
        return `https://api.commerce.ikea.com/${retailUnit}/${language}/${appName}`;
        // For inter testing environments
    }
    else if (retailUnit == 'nl') {
        return `https://${window.location.hostname}/${retailUnit}/${language}/${appName}`;
    }
    else if (baseDomain === 'ikeadt.com') {
        return `https://api.commerce.ikeadt.com/${retailUnit}/${language}/${appName}`;
    }
};
const getBasePath = () => {
    if ([retailUnit, language, appName].every((v) => v === undefined)) {
        return;
    }
    return `/${retailUnit}/${language}/${appName}`;
};
const getAppPath = () => {
    const basePath = getBasePath();
    if (!basePath)
        return;
    return window.location.pathname.replace(basePath, '').replace(/\/index(-([a-z0-9-]+))?\.html/, '');
};
export default {
    appName,
    appPath: getAppPath(),
    backendUrl: getBackendUrl(),
    baseDomain,
    basePath: getBasePath(),
    language,
    retailUnit,
    slotName,
};
